import { __extends } from "tslib";
import { DisplayObject } from '../display/DisplayObject';
//import { TextSymbol } from './TextField';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: StaticText
var StaticText = /** @class */ (function (_super) {
    __extends(StaticText, _super);
    function StaticText() {
        var _this = _super.call(this) || this;
        console.warn('[StaticText] not impolemented');
        return _this;
        /*if (!this._fieldsInitialized) {
            this._initializeFields();
        }*/
    }
    //_symbol: TextSymbol;
    StaticText.prototype.applySymbol = function () {
        console.warn('[StaticText] - applySymbol not impolemented');
        //this._initializeFields();
        //this._setStaticContentFromSymbol(this._symbol);
    };
    StaticText.prototype._canHaveTextContent = function () {
        return true;
    };
    StaticText.prototype._getTextContent = function () {
        return this._textContent;
    };
    Object.defineProperty(StaticText.prototype, "text", {
        get: function () {
            return this._textContent.plainText;
        },
        enumerable: true,
        configurable: true
    });
    StaticText.classInitializer = null;
    StaticText.classSymbols = null;
    StaticText.instanceSymbols = null;
    return StaticText;
}(DisplayObject));
export { StaticText };
